import angular from 'angular';
import delegatedRequestModalComponent from './delegatedRequestModal.component';

let delegatedRequestModalModule = angular.module('delegatedRequestModal', [
])

.component('delegatedRequestModal', delegatedRequestModalComponent)

.name;

export default delegatedRequestModalModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/delegatedRequestModal/delegatedRequestModal.js